
import React from 'react';
import Header from './header';

import { URL } from '../variables';
import { connect } from 'react-redux';
import { mudarUser, logout } from '../actions/AppActions';
import { Redirect, Link } from 'react-router-dom';

import moment from 'moment-timezone';
import Pagination from '@material-ui/lab/Pagination';
import Search from './Search';
import Loader from '../components/Loader';



class Dissertativas extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            msg: '',
            loading_screen: false,
            show_video: false,
            show_solicitar: true,
            show_aceitar: false,
            stream: null,
            redirect: false,
            path: '/sala',
            correcoes: [],
            pagination: { current_page: 1, last_page: 1 },
            processo: {},
            loading_content:false,
            search:''
        }
        this.videoRef = React.createRef();

        // this.videoRef=null;
    }


    async get_correcoes(id,page=1,more=false,search=this.state.search) {
        if(more==false){
            this.setState({ loading_screen: true });
        }
        else{
            this.setState({ loading_content: true });
        }
        fetch(`${URL}api/corretor/get_dissertativas/${id}?page=${page}&search=${search}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);

                    // this.props.mudarLoadingHome(false);
                    setTimeout(() => {
                        this.get_correcoes(id);
                    }, 5000);
                }
                else {
                    this.setState({loading_content:false, loading_screen: false, processo: resp.processo, correcoes: resp.respostas, pagination: resp.pagination });

                }




            } catch (err) {
                console.log(err);
                // this.props.mudarLoadingHome(false);
                setTimeout(() => {
                    this.get_correcoes(id);
                }, 5000);

            }

        })
            .catch((err) => {
                console.log(err);
                // this.props.mudarLoadingHome(false);
                setTimeout(() => {
                    this.get_correcoes(id);
                }, 5000);
            });
    }


    componentDidMount() {
        this.get_correcoes(this.props.processo_id);

    }

    componentWillUnmount() {
        clearTimeout(this.logs_timeout);
    }


    render() {
        let t = this.props.t || {};
        return (
            <div>
                <div className='row'>
                    <Search placeholder={t.search_candidate_placeholder || "Pesquisar pelo número de inscrição do candidato"} buttonText={t.search || 'Buscar'} ValueChange={value => {
                        clearTimeout(this.pesquisarTimeout);
                        this.setState({ search: value })

                        this.pesquisarTimeout = setTimeout(() => {
                            let page = { ...this.state.pagination };
                            page.current_page = 1;
                            this.setState({ loading_screen: true, pagination: page });
                            this.get_correcoes(this.props.processo_id, 1, true, value);



                        }, 500);
                    }} />
                </div>
                {this.state.loading_screen == false && <div className="correcao-list-panel">

                    {this.state.loading_content == false && <div className="correcao-card-list">
                        {this.state.correcoes.map((item, id) => (
                            <Link key={id} to={'/dissertativas/'+this.state.processo.id+'/' + item.id} className="correcao-list-card">
                                <div className="correcao-list-icon">
                                    <i className="mdi mdi-format-list-numbered"></i>
                                </div>
                                <div className="correcao-list-main">
                                    <span>{t.registration || 'Inscrição'} #{item.candidato.numero_inscricao}</span>
                                    <strong>{t.question || 'Questão'} {item.questao_order.order + 1}</strong>
                                    <p>{t.discursive_questions_desc || 'Resposta dissertativa pendente de correção'}</p>
                                </div>
                                <div className="correcao-list-action">
                                    <span>{t.correct || 'Corrigir'}</span>
                                    <i className="mdi mdi-arrow-right"></i>
                                </div>
                            </Link>
                        ))}
                    </div>}
                    {this.state.correcoes.length == 0 && this.state.loading_content == false && <div className="correcao-process-empty">
                        <i className="mdi mdi-clipboard-alert-outline"></i>
                        <p>{t.no_discursive_found || 'Nenhuma questão dissertativa encontrada'}</p>
                    </div>}

                    {this.state.loading_content && <Loader compact title={t.loading_data} description={null} />}
                    {/* <div className="row">
                        <div className="col-12 d-flex justify-content-end">
                            <ReactPaginate
                                previousLabel={'Anterior'}
                                nextLabel={'Próxima'}
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={this.state.total_pages}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={2}
                                onPageChange={this.handlePageClick.bind(this)}
                                containerClassName={'pagination'}
                                subContainerClassName={'pages pagination'}
                                activeClassName={'active'}
                                initialPage={this.state.page - 1}
                            />

                            
                        </div>
                    </div> */}
                    <Pagination
                        className={(this.state.pagination.last_page == 1 ? "hide" : "")}
                        style={{ display: "flex", justifyContent: "flex-end" }}
                        count={this.state.pagination.last_page}
                        value={this.state.pagination.current_page}
                        onChange={(_, value) => {
                            console.log(_, value);
                            let page = { ...this.state.pagination };
                            page.current_page = value;
                            this.get_correcoes(this.props.processo_id, value, true)
                        }}
                    />




                </div>}

                {this.state.loading_screen == true && <Loader title={t.loading_data} description={t.loading_hint} />}
            </div>
        )
    }
}

const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        faculdade: state.AppReducer.faculdade,
        processo: state.AppReducer.processo,
        user: state.AppReducer.user,
    }
);

export default connect(mapsStateToProps, { mudarUser, logout })(Dissertativas);
